export default "__VITE_ASSET__BLWV$OTB__"